import { createSelector } from "@ngrx/store";
import { AppState } from "..";
import { ReasoningType } from "src/app/model/reasoning/ReasoningType";

const featureSelector = (state: AppState) => state.reasoning;

export const selectReasonings = createSelector(
    featureSelector,
    (state) => state.entries,
);

export const selectReasoningByType = (type: ReasoningType) =>
    createSelector(featureSelector, (state) =>
        state.entries.find((e) => e.reasoningType === type),
    );
